import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Callout, Divider, Typography } from 'seagull';
import { useIoContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { costDisplayTextsPath } from '~/models/service-cost/selectors';
import { billingPeriodTextsPath } from '~/utils/billing-period-text';
import { getServiceBulletPoints } from '~/utils/service-description/getServiceBulletPoints';
import styles from './BulletPointsSection.module.scss';
export default function BulletPointsSection(props) {
    const { testId } = props;
    const { getNow } = useIoContext();
    const now = useMemo(()=>getNow(), []);
    const featureFlags = useFeatureFlags();
    const { t: billingTexts } = useLocaleKeys(billingPeriodTextsPath);
    const { t: costDisplayTexts } = useLocaleKeys(costDisplayTextsPath);
    const bulletPoints = getServiceBulletPoints(_object_spread_props(_object_spread({}, props), {
        now,
        featureFlags,
        billingTexts,
        costDisplayTexts
    }));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            bulletPoints.bullets.length > 0 && /*#__PURE__*/ _jsx(Divider, {
                margin: 8
            }),
            /*#__PURE__*/ _jsx("ul", {
                children: bulletPoints.bullets.map((bullet, idx)=>{
                    const indented = typeof bullet === 'object' && bullet !== null && 'indented' in bullet;
                    const content = indented ? bullet.text : bullet;
                    return /*#__PURE__*/ _jsxs(Typography, {
                        noWrap: false,
                        as: "li",
                        testId: testId + "bullet-".concat(idx),
                        className: cn(styles.listItem, indented && styles.indentedItem),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.bullet
                            }),
                            content
                        ]
                    }, idx);
                })
            }),
            bulletPoints.pausedCallout && /*#__PURE__*/ _jsx(Callout, {
                className: styles.section,
                withBorder: true,
                children: bulletPoints.pausedCallout
            })
        ]
    });
}
